// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2tvGjZryiZ3cuJHMXxZQRA {\n  display: block;\n  line-height: 1.5;\n}\n\n._1Cr8lJu48QZ9UxE4ls3tMc {\n  display: block;\n  line-height: 1.5;\n  margin-left: 16px;\n}\n\n._3U4htpcUEjTDuzgngw6NHp {\n  color: #777679 !important;\n  cursor: default;\n  pointer-events: none;\n}\n", ""]);
// Exports
exports.locals = {
	"sideBarItem": "_2tvGjZryiZ3cuJHMXxZQRA",
	"sideBarItemSmall": "_1Cr8lJu48QZ9UxE4ls3tMc",
	"disabled": "_3U4htpcUEjTDuzgngw6NHp"
};
module.exports = exports;
